// Model types
export const MODEL_TYPES = {
  RELATIONAL: 'relational',
  NOSQL: 'nosql',
  ANALYTICAL: 'analytical'
};

// Node types
export const NODE_TYPES = {
  TABLE: 'table',
  COLLECTION: 'collection',
  FACT: 'fact',
  DIMENSION: 'dimension',
  DOCUMENT: 'document',
  VIEW: 'view',
  TEXT: 'text'
};

// Edge types
export const EDGE_TYPES = {
  FOREIGN_KEY: 'foreignKey',
  REFERENCE: 'reference',
  DIMENSION: 'dimension',
  EMBEDDED: 'embedded',
  DEFAULT: 'default'
};

// Field data types
export const DATA_TYPES = {
  RELATIONAL: [
    'INTEGER',
    'BIGINT',
    'SMALLINT',
    'DECIMAL',
    'NUMERIC',
    'FLOAT',
    'REAL',
    'VARCHAR',
    'CHAR',
    'TEXT',
    'DATE',
    'TIME',
    'TIMESTAMP',
    'DATETIME',
    'BOOLEAN',
    'BLOB',
    'JSON',
    'JSONB',
    'XML',
    'UUID',
    'GEOMETRY',
    'GEOGRAPHY'
  ],
  NOSQL: [
    'String',
    'Number',
    'Boolean',
    'Date',
    'Object',
    'Array',
    'ObjectId',
    'Binary',
    'Mixed'
  ],
  ANALYTICAL: [
    'INTEGER',
    'BIGINT',
    'DECIMAL',
    'FLOAT',
    'VARCHAR',
    'DATE',
    'TIMESTAMP',
    'BOOLEAN'
  ]
};

// Cardinality options
export const CARDINALITY = [
  { value: '1:1', label: 'One to One' },
  { value: '1:N', label: 'One to Many' },
  { value: 'N:1', label: 'Many to One' },
  { value: 'N:N', label: 'Many to Many' }
];

// Node colors by type
export const NODE_COLORS = {
  table: '#3b82f6',      // blue
  collection: '#10b981', // green
  fact: '#f59e0b',       // amber
  dimension: '#8b5cf6',  // purple
  document: '#14b8a6',   // teal
  view: '#06b6d4',       // cyan
  text: '#fef9c3'        // yellow (note)
};

// Default node dimensions
export const NODE_DIMENSIONS = {
  width: 250,
  minHeight: 120
};

// Grid settings
export const GRID_SIZE = 15;
export const SNAP_GRID = [GRID_SIZE, GRID_SIZE];

/** Options aligned with https://reactflow.dev/examples/layout/node-collisions */
export const NODE_COLLISION_OPTIONS = {
  maxIterations: Infinity,
  overlapThreshold: 0.5,
  margin: 15,
};

// Auto-save interval (milliseconds)
export const AUTO_SAVE_INTERVAL = 30000; // 30 seconds

// LocalStorage keys
export const STORAGE_KEYS = {
  THEME: 'dbmodeler_theme',
  LAST_MODEL: 'dbmodeler_last_model',
  AUTO_SAVE: 'dbmodeler_auto_save'
};
